export const DEFAULT_ERROR_MESSAGE = 'Что-то пошло не так. Попробуйте еще раз';
